import React, { useState, useEffect } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

const words = ['Strategy', '&', 'High-Stakes', 'Deals.'];

export const HeroSection = ({ onOpenBriefing }) => {
  const [visibleCount, setVisibleCount] = useState(0);
  const [subtitleVisible, setSubtitleVisible] = useState(false);

  useEffect(() => {
    const timers = [];
    words.forEach((_, i) => {
      timers.push(setTimeout(() => setVisibleCount(i + 1), 300 + i * 280));
    });
    timers.push(setTimeout(() => setSubtitleVisible(true), 300 + words.length * 280 + 300));
    return () => timers.forEach(clearTimeout);
  }, []);

  const scrollToNext = () => {
    const el = document.getElementById('trust-bar');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-end text-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <style>{`
          @keyframes livingFrameDrift {
            0%   { transform: scale(1.05) translate(0%, 0%); }
            50%  { transform: scale(1.12) translate(-1.2%, -0.8%); }
            100% { transform: scale(1.05) translate(0%, 0%); }
          }
          .living-frame-bg {
            animation: livingFrameDrift 28s ease-in-out infinite;
            will-change: transform;
          }
        `}</style>
        <img
          src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2600&auto=format&fit=crop"
          alt="Financial district towers at dusk"
          className="living-frame-bg absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#090E1A]/95 via-[#090E1A]/60 to-[#090E1A]/25" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pb-20 md:pb-28">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] font-black text-white tracking-tight leading-[1.1] md:leading-[1.05] mb-6 whitespace-normal lg:whitespace-nowrap drop-shadow-[0_2px_16px_rgba(0,0,0,0.6)]">
          {words.map((word, i) => (
            <React.Fragment key={i}>
              <span className="inline-block" style={{ opacity: i < visibleCount ? 1 : 0, transform: i < visibleCount ? 'translateY(0)' : 'translateY(30px)', transition: 'opacity 0.5s ease, transform 0.5s ease' }}>{word}</span>{' '}
            </React.Fragment>
          ))}
        </h1>

        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8"
          style={{
            opacity: subtitleVisible ? 1 : 0,
            transform: subtitleVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
        >
          <p className="text-lg md:text-xl text-slate-200 font-light drop-shadow-[0_1px_8px_rgba(0,0,0,0.6)]">
            Frontier AI for investment committees and strategy leaders.
          </p>
          <button
            onClick={() => onOpenBriefing && onOpenBriefing('Platform Demo & Capabilities Briefing')}
            className="flex items-center gap-1.5 bg-white text-[#090E1A] text-xs font-semibold px-5 py-2.5 rounded-full hover:bg-slate-100 transition-colors shadow-lg shrink-0"
          >
            Request Briefing <ArrowRight size={14} />
          </button>
        </div>
      </div>

      <button
        onClick={scrollToNext}
        className="relative z-10 mb-8 text-white/50 hover:text-white transition-colors animate-bounce"
        style={{
          opacity: subtitleVisible ? 1 : 0,
          transition: 'opacity 0.6s ease 0.3s',
        }}
      >
        <ChevronDown size={28} />
      </button>
    </section>
  );
};
